var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.tabs),function(tab){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(tab.id === _vm.selected),expression:"tab.id === selected"}],key:tab.id,attrs:{"data-test":`slot-${tab.id}`}},[_vm._t(tab.id)],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }